import setupTooltip from 'initPlugins';
import nextFrame from 'utils/nextFrame';
import overflowTitle from 'components/directives/overflowTitle';
import VueObserveVisibility from 'vue-observe-visibility';
import VueScrollTo from 'vue-scrollto';
import {setupTranslations} from 'translation';
import {setupLocaleParams} from 'utils/calendar/calendarLocaleParams';
import {showNotification} from 'components/Notifications/MNotification/MNotificationManager';
import {LibEventBus} from 'utils/libEventBus';

import BasePopover from 'components/common/BasePopover';
import BaseSelectDropdown from 'components/Inputs/Select/common/BaseSelectDropdown/BaseSelectDropdown';
import DropdownMenu from 'components/Dropdowns/DropdownMenu';
import MButton from 'components/Inputs/Basic/MButton';
import MIcon from 'components/Design/MIcon';
import MProviderIcon from 'components/Design/MProviderIcon';
import MInput from 'components/Inputs/Basic/MInput';
import MLink from 'components/Links/MLink';
import MSelectControl from 'components/Inputs/Select/MSelectControl/MSelectControl';
import SmallSpinner from 'components/common/SmallSpinner';
import SpinnerContainer from 'components/Loaders/SpinnerContainer';
import SkeletonLoader from 'components/common/SkeletonLoader';
import MTitle from 'components/Help/MTitle/MTitle';
import MCheckbox from 'components/Inputs/Basic/MCheckbox';
import TreeSelect from 'components/Inputs/Select/TreeSelect/TreeSelect';
import SearchInput from 'utils/search/SearchInput';
import MHint from 'components/Help/MHint';
import MModalMixin from 'components/Modals/MModal/MModalMixin';
import MModal from 'components/Modals/MModal/MModal';
import MMultiSelect from 'components/Inputs/Select/MMultiSelect/MMultiSelect';
import MultiSelectInput from 'components/Inputs/Select/MultiSelectInput/MultiSelectInput';
import MErrorWrapper from 'components/Wrappers/MErrorWrapper/MErrorWrapper';
import MErrorWrapperMixin from 'components/Wrappers/MErrorWrapper/MErrorWrapperMixin';
import MTable from 'components/Data/Tables/MTable/MTable';
import Pagination from 'components/Data/Pagination/Pagination';
import PaginatedTable from 'components/Data/Tables/PaginatedTable/PaginatedTable';
import TableSettings from 'components/Data/TableSettings/TableSettings';
import MTableCellCombinedControl from 'components/Data/Tables/MTable/cells/MTableCellCombinedControl';
import MTableCellEmpty from 'components/Data/Tables/MTable/cells/MTableCellEmpty';
import MTableCellDefault from 'components/Data/Tables/MTable/cells/MTableCellDefault';
import MTableCellMdash from 'components/Data/Tables/MTable/cells/MTableCellMdash';
import MTableCellIconHint from 'components/Data/Tables/MTable/cells/MTableCellIconHint';
import MTableCellExpandingInput from 'components/Data/Tables/MTable/cells/MTableCellExpandingInput';
import DateRangePicker from 'components/Inputs/Dates/DateRangePicker/DateRangePicker';
import MCalendar from 'components/Inputs/Dates/MCalendar/MCalendar';
import DateInput from 'components/Inputs/Dates/common/DateInput';
import AllItemsBlock from 'components/Inputs/Select/MultiSelectInput/components/AllItemsBlock/AllItemsBlock';
import SelectedItemsBlock from 'components/Inputs/Select/common/SelectedItemsBlock/SelectedItemsBlock';
import ExtendedSelectDropdownControls from 'components/Inputs/Select/common/ExtendedSelectDropdown/ExtendedSelectDropdownControls.vue';
import TableSettingsModal from 'components/Data/TableSettings/TableSettingsModal/TableSettingsModal';
import MHelp from 'components/Help/MHelp.vue';
import InfoPanel from 'components/InfoPanel/InfoPanel.vue';
import Accordion from 'components/Accordion/Accordion.vue';
import AccordionBase from 'components/Accordion/AccordionBase.vue';

let MVue = null;


import TableTabs from 'components/Data/TableTabs/TableTabs';
import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';
import VuePortal from '@linusborg/vue-simple-portal';


export default {
  install (Vue, {translations, params} = {}) {
    /*
     * Other projects using this library may require some self-patched vue object, so save it here.
     * Eg use it while creating modal node
     */
    MVue = Vue;
    setupTooltip(Vue);

    Vue.prototype._$nextFrame = nextFrame;
    overflowTitle(Vue);
    setupTranslations(Vue, translations);
    setupLocaleParams(Vue, params);

    Vue.prototype.$scrollUITo = VueScrollTo.scrollTo;

    Vue.use(VueObserveVisibility);
    Vue.directive('observe-visibility', VueObserveVisibility.ObserveVisibility);
    Vue.use(VuePortal);
  }
};

const mTableCells = {
  MTableCell,
  MTableCellCombinedControl,
  MTableCellEmpty,
  MTableCellDefault,
  MTableCellIconHint,
  MTableCellExpandingInput,
  MTableCellMdash
};

export {

  // EventBus
  LibEventBus,

  // Common
  BasePopover,
  BaseSelectDropdown,
  DropdownMenu,
  MButton,
  MIcon,
  MProviderIcon,
  MInput,
  MLink,
  MSelectControl,
  SmallSpinner,
  SpinnerContainer,
  SkeletonLoader,
  MTitle,
  TreeSelect,
  SearchInput,
  showNotification,
  MCheckbox,
  MHint,
  MModalMixin,
  MModal,
  setupTooltip,
  MMultiSelect,
  MultiSelectInput,
  MErrorWrapper,
  MErrorWrapperMixin,
  InfoPanel,

  DateRangePicker,
  MCalendar,
  DateInput,
  MHelp,

  Pagination,
  TableTabs,

  // MTable
  MTable,
  PaginatedTable,
  mTableCells,
  TableSettings,
  TableSettingsModal,

  AllItemsBlock,
  SelectedItemsBlock,
  ExtendedSelectDropdownControls,

  MVue,

  Accordion,
  AccordionBase
};
